<template>
  <div class="site-selector-container in-page-selector" v-bind:class="{noheader:noheader}">
    <div class="custom-tab">
      <div class="custom-tab-header" v-bind:class="{'hidden-header':minimize}">
        <span>Select Websites</span>
        <div class="relative">
          <span v-if="slug !=''" class="install"><b-link @click="installBulkAction()">Click</b-link> to install and activate {{plugin}} plugin in all sites</span>
          <b-button class="toggle" v-bind:class="{'install':slug !=''}" v-b-tooltip.hover title="Hide/Show site lists" @click="hideAndShow()"><down-arrow-icon v-if="minimize == true" class="icon-default down-icon"></down-arrow-icon><up-arrow-icon v-else class="icon-default down-icon"></up-arrow-icon></b-button>
        </div>
      </div>
      <div class="custom-tab-body" v-if="minimize == false">
        <b-row>
          <b-col class="flex-column groups-column">
            <div class="selector-title p-2">
              By groups
            </div>
            <div class="groups-wrapper px-2">
              <b-form-group>
                <b-form-checkbox stacked v-for="(group) in groups" class="group-name darkbg" size="sm" :key="group.groupID" :checked="group.isSelected" @change="selectGroup(group,$event) ">{{group.name}}</b-form-checkbox>
              </b-form-group>
            </div>
          </b-col>
          <b-col class="flex-column sites-column">
            <div class="site-options-cont">
                <div class="selector-title pr-3">
                  By websites
                </div>
              <div class="relative search-input-container">
                <b-input v-model="searchText" class="mb-2 mr-sm-2 mb-sm-0 search-input" id="search_text" type="text" placeholder="Search sites" />
                <div class="search-icon-container">
                  <magnifier-icon class="icon-default search-icon"></magnifier-icon>
                </div>
              </div>
              <div class="selector-title pl-3">Select:
                <a @click="selectAll()">All</a>
                <a @click="selectInvert()">Invert</a>
                <a @click="selectNone()">None</a>
              </div>
            </div>
            <div class="sites-wrapper px-2">
              <spinner size="small" v-if="spinner" ></spinner>
              <b-form-group>
                <b-form-checkbox-group id="checkboxes2" size="sm" name="flavour2" v-model="selectedSiteIds">
                  <b-form-checkbox class="site-name-cont blue-checked darkbg" size="sm" v-for="(site) in sites" :disabled="slug !='' && (!site.plugins || !site.plugins.isActivated) || (googleAddon !='' && !inArray(googleData, site.siteID))" :key="site.siteID" :value="site.siteID" :title="site.name">
                    <div v-if="slug !='' && !site.plugins" class="site-name" v-b-popover.hover.top.html="popoverText('install')">
                      <b-img-lazy class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
                      <span class="site-name" :title="site.name" @click="installNotInstalledPlugin(site.siteID)">
                        {{site.name}}
                      </span>
                    </div>
                    <div v-else-if="slug !='' && site.plugins && site.plugins == 'needReloadData'" class="site-name" v-b-popover.hover.top.html="popoverText('needReloadData')">
                      <b-img-lazy class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
                      <span class="site-name" :title="site.name">
                        {{site.name}}
                      </span>
                    </div>
                    <div v-else-if="slug !='' && site.plugins && site.plugins != 'needReloadData' && !site.plugins.isActivated" class="site-name" v-b-popover.hover.top.html="popoverText('activate')">
                      <b-img-lazy class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
                      <span class="site-name" :title="site.name" @click="activatePlugin(site.siteID)">
                        {{site.name}}
                      </span>
                    </div>
                    <div v-else-if="slug !='' && site.plugins && site.plugins.isActivated" class="site-name">
                      <b-img-lazy class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
                      <span class="site-name" :title="site.name">
                        {{site.name}}
                      </span>
                    </div>
                    <div v-else-if="googleAddon !='' && inArray(googleData, site.siteID) " class="site-name">
                      <b-img-lazy class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
                      <span class="site-name" :title="site.name">
                        {{site.name}}
                      </span>
                    </div>
                    <div v-else-if="googleAddon !='' && !inArray(googleData, site.siteID) " class="site-name">
                      <b-img-lazy class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
                      <span class="site-name" :title="site.name" @click="editModalEvent(site)">
                        {{site.name}}
                      </span>
                    </div>
                    <div v-else-if="slug =='' && googleAddon == ''" class="site-name">
                      <b-img-lazy class="favicon-img" :src="appInfo.APP_URL_V2+site.favicon" />
                      <span class="site-name" :title="site.name">
                        {{site.name}}
                      </span>
                    </div>
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import MagnifierIcon from '../../assets/lens.svg';
import DownArrowIcon from '../../assets/down.svg';
import UpArrowIcon from '../../assets/up.svg';
import { EventBus } from '../../event/event-bus.js';

import _ from 'lodash';
export default {
  name: 'siteselector',
  components: {
    MagnifierIcon,
    DownArrowIcon,
    UpArrowIcon,
  },
  // props: ['selected', 'noheader'],
  props: {
      'selected' : {
        type: Array,
      },
      'noheader' : {
        type: Boolean,
        default: false
      },
      'slug' : {
        type: String,
        default: ''
      },
      'plugin' : {
        type: String,
        default: ''
      },
      'installslug':{
        type: String,
        default: ''
      },
      'selectall': {
        type: Boolean,
        default: false
      },
      'googleAddon': {
        type: String,
        default: ''
      },
      'googleData': {
        type: Array,
        default: Array
      }
  },
  data() {
    return {
      serverURL: window.serverURL,
      searchText: '',
      selectedSiteIds: [],
      selectedGroups: [],
      minimize: false,
      currentSite: {},
      sites: [],
      groups: [],
      spinner: true
    };
  },
  mounted() {
    setTimeout(()=>{
      this.initSites();
      this.initGroups();
      this.spinner = false;
      this.selectedSiteIds = this.selected;
      if (this.selectall) {
        this.selectAll();
      }
    }, 10);
  },
  computed: {
    appInfo() {
      return this.$store.getters.getAppInfo;
    },
    sitesByPluginSlug() {
      let pluginsAndThemes = this.$store.getters.getPluginsAndThemes;
      return _.filter(pluginsAndThemes, { URI: this.slug });
    }
  },
  watch: {
    selectedSiteIds(updatedValue) {
      this.$emit('update:selected', updatedValue);
      // 
    },
    selected(newValue) {
      this.selectedSiteIds = this.selected;
      
    },
    searchText(){
      this.initSites();
    }
  },
  methods: {
    initSites() {
      let allSites = this.$store.getters.getSites;
      let filtered = _.filter(allSites, site => {
        site.plugins = this.getPluginBySite(site.siteID);
        return (
          site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
        );
      });
      this.sites = _.sortBy(filtered, [data => data.name.toLowerCase()]);
    },
    initGroups() {
      let allGroups = this.$store.getters.getGroups;
      this.groups = _.sortBy(allGroups, [data => data.name.toLowerCase()]);
    },
    selectAll() {
      let tempArray = [];
      _.each(this.sites, site => {
        if (this.slug != '' && site.plugins.isActivated || (this.googleAddon !='' && this.inArray(this.googleData, site.siteID))) {
          tempArray.push(site.siteID);
        }else if (this.slug == '' && this.googleAddon =='') {
          tempArray.push(site.siteID);
        }
      });
      this.selectedSiteIds = tempArray;
    },
    selectInvert() {
      let tempArray = [];
      _.each(this.sites, site => {
        if (this.selectedSiteIds.indexOf(site.siteID) === -1) {
          if (this.slug != '' && site.plugins.isActivated || (this.googleAddon !='' && this.inArray(this.googleData, site.siteID))) {
            tempArray.push(site.siteID);
          }else if (this.slug == '' && this.googleAddon =='') {
            tempArray.push(site.siteID);
          }
        }
      });
      this.selectedSiteIds = tempArray;
    },
    selectNone() {
      this.selectedSiteIds = [];
    },
    selectGroup(group, isSelected) {
      _.each(this.sites, site => {
        if (site.groupIDs) {
          let index = site.groupIDs.indexOf(group.groupID);
          if (index > -1) {
            if (isSelected) {
              this.selectedSiteIds.push(site.siteID);
            } else {
              this.selectedSiteIds.splice(index, 1);
            }
          }
        }
      });
    },
    getPluginBySite(siteID){
        let find = _.find(this.sitesByPluginSlug, {'siteID':siteID});
        if (typeof find == 'undefined') {
          return this.getSiteInPluginsAndThemes(siteID);;
        }else{
          let index = _.indexOf(this.selectedSiteIds, siteID);
          if (index > -1) {
            return {'isActivated' : true}
          }else{
            return find;
          }
        }
    },
    getSiteInPluginsAndThemes(siteID){
      let find = _.find(this.$store.getters.getPluginsAndThemes, {'siteID':siteID});
        if (typeof find == 'undefined') {
          return 'needReloadData';
        }else{
          let index = _.indexOf(this.selectedSiteIds, siteID);
          if (index > -1) {
            return {'isActivated' : true}
          }else{
            return false;
          }
        }
    },
    popoverText(type){
      if (type == 'install') {
        return '<div class="popover-site">Click to Install and Activate '+this.plugin+'</div>';
      }else if (type == 'activate') {
        return '<div class="popover-site">Click to Activate '+this.plugin+'</div>';
      }else if (type == 'needReloadData') {
        return '<div class="popover-site">Not communicable. Please reload data.</div>';
      }
    },
    installNotInstalledPlugin(siteID){
      let payload = {
        requiredData: {
          installNotInstalledPlugin: {},
        }
      };
      payload.requiredData.installNotInstalledPlugin.type = 'plugins';
      payload.requiredData.installNotInstalledPlugin.siteID = siteID;
      payload.requiredData.installNotInstalledPlugin.plugin_slug = this.installslug;
      this.$store.dispatch("sendAction", payload).then(response => {
          this.selectedSiteIds.push(siteID);
          let request = {
            requiredData: {
              getPluginsAndThemesV3: 1,
            }
          };
          let params = {
            plugins:[]
          };
          let args = {
            siteIDs:[]
          };
          let data = response.data.installNotInstalledPlugin;
          params.plugins[0]=data[0].download_link;
          params.activate = true;
          args.siteIDs[0] = data[1];
          args.params = params;
          request.args = args;
          request.action = 'installPlugins';
          this.$store.dispatch("sendAction", request).then(response => {
            let pluginInintializationReload = {
              requiredData: {
                pluginInintializationReload: this.plugin,
              }
            };
            this.$store.dispatch("sendAction", pluginInintializationReload).then(response => {
            });
          });

      });
    },
    activatePlugin(siteID){
      let data = {'name': this.installslug, 'path': this.slug, 'action': 'activate'};
      let payload = {
        requiredData: {
          getPluginsAndThemesV3: 1,
        }
      };
      payload.action = 'managePlugins';
      payload.args = {};
      payload.args.params = {};
      payload.args.params[siteID] = {};
      payload.args.params[siteID]['plugins'] = [];
      payload.args.params[siteID]['plugins'].push(data);
      this.$store.dispatch("sendAction", payload).then(response => {
        this.selectedSiteIds.push(siteID);
      });
    },
    installBulkAction(){
      let payload = {
        requiredData: {
          installNotInstalledPlugin: {},
        }
      };
      let filtered = _.filter(this.sites, {'plugins' : false});
      let siteIDs = _.map(filtered, site =>{
        return site.siteID
      });
      console.log(siteIDs);
      payload.requiredData.installNotInstalledPlugin.type = 'plugins';
      payload.requiredData.installNotInstalledPlugin.siteID = siteIDs;
      payload.requiredData.installNotInstalledPlugin.plugin_slug = this.installslug;
      this.$store.dispatch("sendAction", payload).then(response => {
          let request = {
            requiredData: {
              getPluginsAndThemesV3: 1,
            }
          };
          let params = {
            plugins:[]
          };
          let args = {
            siteIDs:[]
          };
          let data = response.data.installNotInstalledPlugin;
          params.plugins[0]=data[0].download_link;
          params.activate = true;
          args.siteIDs = data[1];
          args.params = params;
          request.args = args;
          request.action = 'installPlugins';
          this.$store.dispatch("sendAction", request).then(response => {
            let pluginInintializationReload = {
              requiredData: {
                pluginInintializationReload: this.plugin,
              }
            };
            this.$store.dispatch("sendAction", pluginInintializationReload).then(response => {
            });
          });

      });
    },
    hideAndShow(){
      if (this.minimize) {
        this.minimize = false;
      }else{
        this.minimize = true;
      }
    },
    inArray(collection, value){
      let index = collection.indexOf(value);
      if (index > -1) {
        return true;
      }else{
        return false;
      }
    },
    editModalEvent(site) {
      EventBus.$emit('open-edit-modal', {'site': site, 'addon': 'googleAnalytics'});
    },
  }
};
</script>

<style>
</style>
